export class LoraTable {
    id: number;
    dt0: any;
    wd0: string;
    rxInfoLoraSnr: number;
    rxInfoRssi: number;
    modTime: any;
    dts: any;
    dv0: number;
    epdt: number;
    eplt: number;
    max: number;
    meff: number;
    min: number;
    mv0: number;
    snw: number;
    temp: number;
    vbat: number;
    wm0: string;
    wp: string;
}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/interfaces/lora-table.ts